export default __webpack_public_path__ + "static/media/built_connect.0fac3f64.png";